export default "__VITE_ASSET__CryqLn$F__"